// The Queue's company + team toggles (2026-10-07): 1A, AM and Support. The
// inclusion rule itself is conversationMatchesToggles() in @cxhub/shared (the
// server applies the same one); this file holds who sees the Support toggle
// and what each user starts with, so the default is one place to change.
import { normalizeToggles } from '@cxhub/shared'

// Admins, and agents with Support Email or Support Voice. A Tasks-only agent
// sees task contacts under 1A / AM (2026-10-14), so has no Support toggle.
export function hasSupportToggleAccess(me, { isAdmin = (me?.roles ?? []).includes('admin') } = {}) {
  return Boolean(isAdmin || me?.supportEmail || me?.supportVoice)
}

// Who is looking, for the task contacts' toggle rule (taskMatchesToggles() in
// @cxhub/shared, 2026-10-14): { admin, tasks, supportEmail, supportVoice }.
export function toggleViewer(me, { isAdmin = (me?.roles ?? []).includes('admin') } = {}) {
  if (isAdmin) return { admin: true }
  return { admin: false, tasks: Boolean(me?.tasksEnabled && me?.canUseTasks), supportEmail: Boolean(me?.supportEmail), supportVoice: Boolean(me?.supportVoice) }
}

// What the toggles reset to: all three for anyone with Support access (on
// first load and on every Queue click), otherwise 1A + AM. Jenn plans to
// revisit this default.
export function defaultToggleSelection(me, opts) {
  return hasSupportToggleAccess(me, opts) ? ['1A', 'AM', 'Support'] : ['1A', 'AM']
}

// A saved selection, cleaned: unknown values gone, and Support dropped
// silently for someone without access.
export function sanitizeToggleSelection(saved, me, opts) {
  const clean = normalizeToggles(Array.isArray(saved) ? saved : [])
  return hasSupportToggleAccess(me, opts) ? clean : clean.filter((t) => t !== 'Support')
}
